import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cart-added-modal',
  templateUrl: './cart-added-modal.component.html',
  styleUrls: ['./cart-added-modal.component.scss'],
})
export class CartAddedModalComponent {

  constructor(private modalController: ModalController) {}

  public continueShopping() {
    void this.modalController.dismiss({ action: 'shopping' });
  }

  public goToCart() {
    void this.modalController.dismiss({ action: 'cart' });
  }
}
